import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translateAR from './locales/res/ar.json';
import translateDE from './locales/res/de.json';
import translateEN from './locales/res/en.json';
import translateES from './locales/res/es-rES.json';
import translateFR from './locales/res/fr.json';
import translateJA from './locales/res/ja.json';
import translateKK from './locales/res/kk-rKZ.json';
import translatePL from './locales/res/pl.json';
import translatePT from './locales/res/pt-rPT.json';
import translateRU from './locales/res/ru.json';
import translateSV from './locales/res/sv.json';
import translateTH from './locales/res/th.json';
import translateVI from './locales/res/vi.json';
import translateZH from './locales/res/zh-rCN.json';
import translateKO from './locales/res/ko.json';
import translateIT from './locales/res/it.json';
import translateZH_HK from './locales/res/zh-rHK.json';
import translateZH_TW from './locales/res/zh-rTW.json';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ar: { translation: translateAR },
  de: { translation: translateDE },
  en: { translation: translateEN },
  es: { translation: translateES },
  fr: { translation: translateFR },
  ja: { translation: translateJA },
  kk: { translation: translateKK },
  pl: { translation: translatePL },
  pt: { translation: translatePT },
  ru: { translation: translateRU },
  sv: { translation: translateSV },
  th: { translation: translateTH },
  vi: { translation: translateVI },
  zh: { translation: translateZH },
  ko: { translation: translateKO },
  it: { translation: translateIT },
  "zh-HK": { translation: translateZH_HK },
  "zh-TW": { translation: translateZH_TW }
};

const supportedLanguage = ['ar', 'de', 'en', 'es', 'fr', 'ja', 'kk', 'pl', 'pt', 'ru', 'sv', 'th', 'vi', 'zh', 'ko', 'it', 'zh-HK', 'zh-TW'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    supportedLngs: supportedLanguage,
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 2
    }
  });

export default i18n;
